(ns frontend.view.grid.zap-vaults-grid.view
  (:require [common.localization :as loc]
            [frontend.page-components.default-page-layout :as default-page-layout]
            [frontend.routing :as routing]
            [frontend.state.current-session :as session]
            [frontend.ux-overhaul.listing.zap-vault.view :as zap-vault-listing]
            [frontend.view.grid.zap-vaults-grid.event :as event]
            [frontend.view.grid.zap-vaults-grid.modals :as modals]
            [frontend.view.grid.zap-vaults-grid.sub :as sub]
            [re-frame.core :as rf]
            [ui.components.button.view :as button]
            [ui.components.input.search :as search]
            [ui.components.loading-spinner.view :as loading-spinner]
            [frontend.ux-overhaul.page-components.navigation.events :as nav-events]
            [ui.editors.labelled-input.view :as labelled-input]
            [ui.view.card.shared-components.entity-table :as entity-table]))

(defn toolbar
  []
  (let [show-inactive? @(rf/subscribe [::sub/show-inactive?])
        show-only-my? @(rf/subscribe [::sub/show-only-my?])
        search-text @(rf/subscribe [::sub/search-text])]
    [:div
     {:class "flex flex-row gap-2 p-2"}
     [:div
      {:class "flex flex-row justify-start"}
      [search/view
       {:value     search-text
        :on-change (fn [v]
                     (rf/dispatch [::event/set-search-text v]))}]]
     [:div
      {:class "flex flex-1 flex-row gap-2 justify-end align-items-center"}
      [labelled-input/view
       {:label       (loc/tr :show-inactive-vaults?)
        :value       show-inactive?
        :horizontal? true
        :editor-type :editor.type/toggle
        :on-change   (fn [v]
                       (rf/dispatch [::event/set-show-inactive v]))}]
      [labelled-input/view
       {:label       (loc/tr :show-my-vaults-only?)
        :value       show-only-my?
        :horizontal? true
        :editor-type :editor.type/toggle
        :on-change   (fn [v]
                       (rf/dispatch [::event/set-show-only-my v]))}]
      [button/sm-primary-solid
       {:on-click (fn [_]
                    (rf/dispatch [::event/create-new-vault]))}
       [:i.fal.fa-plus]
       (loc/tr :create-new-vault)]]]))

(defn view
  []
  (let [loading? @(rf/subscribe [::sub/loading?])
        table-data @(rf/subscribe [::sub/table-data])
        fields @(rf/subscribe [::sub/table-columns])]
    (if loading?
      [loading-spinner/circle]
      [:div
       {:class "flex flex-col gap-5 grow p-4"}
       [entity-table/view
        {:config          {:columns     fields
                           :sort-model  [{:field     :zap-vault/name
                                          :direction :asc}]
                           :entity-type :entity.type/zap-vault}
         :data            table-data
         :selected-row-id nil
         :on-row-clicked  (fn [{:keys [entity-id]}]
                            (rf/dispatch [::nav-events/navigate-to {:path [:entity.type/zap-vault :id entity-id :tab :documents]}])
                            )}]])))

(defmethod routing/render-view :zap-vaults-grid
  [{:keys []}]
  (if (session/new-grid-2023?)
    [default-page-layout/view
     [:<>
      [zap-vault-listing/page-content]]]
    (do
      (rf/dispatch [::event/init])
      [default-page-layout/view
       [:<>
        [modals/view]
        [toolbar]
        [view]]])))
